/* eslint-disable no-unused-vars */
export enum SpecialistType {
  NURSE = 'nurse',
  SPECIALIST = 'specialist',
}
